import { FC, useState } from 'react';

import { services } from '@project/API';
import { useStore } from '@project/components/hooks';
import { CartogramStore } from '@project/store/Cartogram/CartogramStore';
import { observer } from 'mobx-react';
import { Cartograms } from '../components';
import { CartogramStoreProvider } from '../context';

export const CartogramsPage: FC = observer(function CartogramsPage() {
  const { map } = useStore();

  const [cartogramStore] = useState(
    () => new CartogramStore(services, map.mapProperties),
  );

  return (
    <CartogramStoreProvider value={cartogramStore}>
      <Cartograms />
    </CartogramStoreProvider>
  );
});
